import { render } from "./TeamComplianceDashboard.vue?vue&type=template&id=5fc1262c&scoped=true"
import script from "./TeamComplianceDashboard.vue?vue&type=script&lang=js"
export * from "./TeamComplianceDashboard.vue?vue&type=script&lang=js"

import "./TeamComplianceDashboard.vue?vue&type=style&index=0&id=5fc1262c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc1262c"]])

export default __exports__